import { render } from "./HomeHealthTips.vue?vue&type=template&id=711d72c7&scoped=true"
import script from "./HomeHealthTips.vue?vue&type=script&lang=js"
export * from "./HomeHealthTips.vue?vue&type=script&lang=js"

import "./HomeHealthTips.vue?vue&type=style&index=0&id=711d72c7&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711d72c7"]])

export default __exports__